'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _immutable = require('immutable');

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.dashboard-event-modal', ['ngMaterial']).factory('fEventParticipantsModal', function ($mdDialog, $mdMedia) {
  return function (ev, feis, event) {
    return $mdDialog.show({
      controller: 'EventParticipantsModalController',
      template: require('./tpl.html'),
      fullscreen: $mdMedia('xs'),
      targetEvent: ev,
      locals: {
        feis: feis,
        event: event
      }
    });
  };
}).controller('EventParticipantsModalController', function ($scope, $mdDialog, $ngRedux, feis, event) {
  $scope.event = event;

  $ngRedux.dispatch((0, _events.getParticipants)(feis.id, event.id));
  $ngRedux.connect(function (state) {
    return {
      isLoading: (0, _paths.getParticipantsOfAnEvent)(state, event.id).get('loading'),
      participants: (0, _paths.getParticipantsOfAnEvent)(state, event.id) || (0, _immutable.List)(),

      // Check if the first participant has a competitor # assigned
      // If she has, then we display the # column for all participants
      // If not, it means that no-one has been assigned a competitor # yet
      hasCompetitorNumAssigned: !!(0, _paths.getParticipantsOfAnEvent)(state, event.id).getIn([0, 'competitor'])
    };
  })($scope);

  $scope.close = function () {
    $mdDialog.cancel();
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/event-modal/index.js
// module id = 520
// module chunks = 0